export class PostGetProviderDetailsRequest {
    providerID?: string;
    cityOrZip?: string;
    latitude?: number;
    longitude?: number;
}